import React from 'react'
import ListItemMenuStyle from '../../styles/ListItemMenuStyle'
import Button from '@material-ui/core/Button'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'

const ITEM_HEIGHT = 48

class ListItemMenu extends React.Component {
  state = {
    anchorEl: null,
  }

  handleMenuClick = event => {
    this.setState({ anchorEl: event.currentTarget })
  }

  handleMenuClose = () => {
    this.setState({ anchorEl: null })
  }

  render() {
    const { options } = this.props
    const { anchorEl } = this.state
    const open = Boolean(anchorEl)
    return (
      <ListItemMenuStyle>
        <Button
          className="moreButton"
          aria-label="More"
          aria-owns={open ? 'long-menu' : undefined}
          aria-haspopup="true"
          onClick={e => e.stopPropagation()}
          onMouseUp={this.handleMenuClick}
          color="primary"
        >
          <MoreVertIcon />
        </Button>
        <Menu
          id="long-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={this.handleMenuClose}
          PaperProps={{
            style: {
              maxHeight: ITEM_HEIGHT * 4.5,
            },
          }}
        >
          {options.map(option => (
            <MenuItem
              key={option.title}
              onClick={this.handleMenuClose}
              onMouseUp={() => option.action()}
            >
              {option.title}
            </MenuItem>
          ))}
        </Menu>
      </ListItemMenuStyle>
    )
  }
}

export default ListItemMenu
